import React from 'react';

export default function Badge({ type }) {
  const color = {
    metric: '#0d6efd',
    formula: '#6f42c1',
    combined: '#198754',
    header: '#adb5bd',
    blank: '#dee2e6',
  }[type] || '#adb5bd';
  return (
    <span style={{
      background: color,
      color: type === 'blank' ? '#6c757d' : '#fff',
      borderRadius: 4,
      padding: '2px 8px',
      fontSize: 11,
      fontWeight: 600,
      textTransform: 'uppercase',
    }}>{type}</span>
  );
}
